import { DEFAULT_QUERY_BUILDER_TAB_COLORS } from 'src/modules/query-builder/constants';

export const getTargetColor = colors => {
  const firstIndex = DEFAULT_QUERY_BUILDER_TAB_COLORS.findIndex(
    color => colors.indexOf(color.key) === -1
  );

  return DEFAULT_QUERY_BUILDER_TAB_COLORS[firstIndex].key;
};
